import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { ContainerOutlined, ScheduleOutlined, AccountBookOutlined, DeliveredProcedureOutlined, ReconciliationOutlined, InteractionOutlined, MessageOutlined, NotificationOutlined, BulbOutlined, DashboardOutlined} from '@ant-design/icons';
import { Layout, Menu } from 'antd';

import { CheckUser } from './api';
import { locales } from '../locales';

import { Doc } from '../doc';
import { DocDetailComment } from '../doc/DocDetailComment';
import { Forecast } from '../forecast';
import { Pay } from '../pay';
import { BillingDetail } from '../billingDetail';
import { Acceptance } from '../acceptance';
import { Deliery, DeliveryOutput } from '../delivery';
import { OrderResponse } from '../orderResponse';
import { Notification } from '../notificate';
import { Estimation } from '../estimation'
import { Model } from '../model'
import { Inventory } from '../inventory';
import { useUser } from '../authorization';
import { SupplierEstimates } from '../supplierEstimates';
import { Guide } from '../guide';
import { Home } from '../home'

import { SuppierCommnunityFakeRouter } from './SuppierCommnunityFakeRtouer'
import { SuppierCommnunityAgreement } from './SuppierCommnunityAgreement';

import './header.css';
import './agreement.css';
import './siderMenu.css';
import './index.css'


const { SubMenu } = Menu;

export function SuppierCommnunityRouter() {
  const user = useUser();
  const currentLang = locales.getLang();  // 現在のページの言語を取得する

  // ページの言語が英語の場合、サイドバーの幅は280、それ以外の場合は200
  const differentSiderWidht = currentLang === 'en-US' ? 280 : 200

  // ルーティングアドレスを取得する
  let url = new URL(window.location.href)
  let routerAddress = url.pathname

  let openSubMenuKey: Array<string> = []  // 現在のルートのドロップダウンサイドバーリストが展開されます
  let selectItemKey: Array<string> = []  // 現在選択されているルートのドロップダウンサイドバーリスト
  if(routerAddress !== null && routerAddress !== ''){
    // 現在展開されているドロップダウンサイドバーを決定する
    if('/orderresponses' === routerAddress) openSubMenuKey = ['delivery']
    if('/deliveryoutput' === routerAddress) openSubMenuKey = ['delivery']
    if('/deliveries' === routerAddress) openSubMenuKey = ['delivery']

    if('/estimations' === routerAddress) openSubMenuKey = ['quotation']
    if('/supplierestimates' === routerAddress) openSubMenuKey = ['quotation']

    if('/models' === routerAddress) openSubMenuKey = ['mold']
    if('/modelassets' === routerAddress) openSubMenuKey = ['mold']

    if('/pays' === routerAddress) openSubMenuKey = ['pay']
    if('/billingDetail' === routerAddress) openSubMenuKey = ['pay']

    // 現在選択されているルートを決定する
    if('/orderresponses' === routerAddress) selectItemKey = ['orderresponses']
    if('/deliveryoutput' === routerAddress) selectItemKey = ['deliveryoutput']
    if('/deliveries' === routerAddress) selectItemKey = ['deliveries']

    if('/forecasts' === routerAddress) selectItemKey = ['forecasts']

    if('/pays' === routerAddress) selectItemKey = ['pays']
    if('/billingDetail' === routerAddress) selectItemKey = ['billingDetail']

    if('/acceptances' === routerAddress) selectItemKey = ['acceptances']

    if('/estimations' === routerAddress) selectItemKey = ['estimations']
    if('/supplierestimates' === routerAddress) selectItemKey = ['supplierestimates']

    if('/models' === routerAddress) selectItemKey = ['models']
    if('/modelassets' === routerAddress) selectItemKey = ['modelassets']
    if('/modelassets' === routerAddress) selectItemKey = ['modelassets']

    if('/docs' === routerAddress) selectItemKey = ['docs']

    if('/home' === routerAddress) selectItemKey = ['home']
    if('/dashboard' === routerAddress) selectItemKey = ['home']

    if('/guide' === routerAddress) selectItemKey = ['guide']

  }

  // ユーザーが同意したかどうかを取得
  let userReaded = CheckUser()

  const router = <Layout id='router'>
    <Layout.Sider className="site-layout-background" width={differentSiderWidht}>
      <Menu theme="light" mode="inline" defaultOpenKeys={openSubMenuKey} defaultSelectedKeys={selectItemKey}>
        <SubMenu key="delivery" title={<>
          <DeliveredProcedureOutlined />
          <FormattedMessage id='delivery' /> </>}>
          <Menu.Item key='orderresponses' >
            <Link to="/orderresponses?finishFlag=0">
              <InteractionOutlined />
              <FormattedMessage id='orderResponse' />
            </Link>
          </Menu.Item>
          {user?.isSupplier &&
          <Menu.Item key='deliveryoutput' >
            <Link to="/deliveryoutput">
              <ReconciliationOutlined />
              <FormattedMessage id='delivery.unprocessedlist' />
            </Link>
          </Menu.Item>
          }
          <Menu.Item key='deliveries' >
            <Link to="/deliveries?deliveryStatus=001">
              <ReconciliationOutlined />
              <FormattedMessage id='delivery.re-output' />
            </Link>
          </Menu.Item>
          {/* <Menu.Item >
            <Link to="/deliveryManifests">
              <FileDoneOutlined />
              <FormattedMessage id='manifest' />
            </Link>
          </Menu.Item> */}
        </SubMenu>
         {!user?.companyId?.endsWith('R') &&
        <Menu.Item key='forecasts'>
          <Link to="/forecasts">
            <ScheduleOutlined />
            <FormattedMessage id='forecast' />
          </Link>
        </Menu.Item>
        }
        {
          user?.serviceState === 'jp' && 
            <SubMenu key="pay" title={
              <>
                <ContainerOutlined />
                <FormattedMessage id='pay' />
              </>
            }>
              <Menu.Item key='pays'>
                <Link to="/pays">
                  <AccountBookOutlined />
                  <FormattedMessage id='pays' />
                </Link>
              </Menu.Item>
              <Menu.Item key='billingDetail'>
                <Link to="/billingDetail">
                  <AccountBookOutlined />
                  <FormattedMessage id='billingDetail' />
                </Link>
              </Menu.Item>
            </SubMenu>
        }
        <Menu.Item key='acceptances'>
          <Link to="/acceptances">
            <AccountBookOutlined />
            <FormattedMessage id='acceptance' />
          </Link>
        </Menu.Item>
        <SubMenu key="quotation" title={<>
          <ContainerOutlined />
          <FormattedMessage id='estimate' /> </>}>
          <Menu.Item key='estimations'>
            <Link to="/estimations">
              <ContainerOutlined />
              <FormattedMessage id='estimatesSub' />
            </Link>
          </Menu.Item>
          <Menu.Item key='supplierestimates'>
            <Link to="/supplierestimates">
              <ContainerOutlined />
              {user?.isSupplier &&
                <FormattedMessage id='supplierEstimates.supplier' />}
              {!user?.isSupplier &&
                <FormattedMessage id='supplierEstimates' />}
            </Link>
          </Menu.Item>
        </SubMenu>
        {/* 金型 */}
        {!user?.isSupplier &&
          <SubMenu key="mold" title={<>
            <MessageOutlined />
            <FormattedMessage id='modelManagement' /> </>}>
              <Menu.Item key='models'>
                <Link to="/models?deleteFlag=0">
                  <NotificationOutlined />
                  <FormattedMessage id='model' />
                </Link>
              </Menu.Item>
            <Menu.Item key='modelassets'>
              <Link to="/modelassets">
                <NotificationOutlined />
                <FormattedMessage id='inventoryConfirm' />
              </Link>
            </Menu.Item>
          </SubMenu>
          }
          {(user?.isSupplier && !user?.companyId?.endsWith('R'))&&
            <Menu.Item key='modelassets'>
              <Link to="/modelassets">
                <NotificationOutlined />
                <FormattedMessage id='inventory' />
              </Link>
            </Menu.Item>
          }
          <Menu.Item key='docs'>
          <Link to="/docs">
            <ContainerOutlined />
            <FormattedMessage id='docInfo' />
          </Link>
        </Menu.Item>
        <Menu.Item key='home'>
          <Link to="/home">
            <DashboardOutlined />
            <FormattedMessage id='home' />
          </Link>
        </Menu.Item>
        <Menu.Item key='guide'>
          <Link to="/guide">
            <BulbOutlined />
            <FormattedMessage id='guide' />
          </Link>
        </Menu.Item>
        {/* <SubMenu key="sub2" title={<>
          <MessageOutlined />
          <FormattedMessage id='notification' /> </>}>
          <Menu.Item>
            <Link to="/notifications">
              <NotificationOutlined />
              <FormattedMessage id='subnotification' />
            </Link>
          </Menu.Item>
        </SubMenu> */}
      </Menu>
    </Layout.Sider>
    <Layout.Content className="site-layout-background">
      <Switch>
        <Route path="/guide" >
          <Guide />
        </Route>
        <Route path="/docs/comment/:documentId/:supplier" >
          <Doc />
        </Route>
        <Route path="/docs/:id/:supplier" >
          <Doc />
        </Route>
        <Route path="/docs/:id" >
          <Doc />
        </Route>
        <Route path="/docs" >
          <Doc />
        </Route>
        <Route path="/deliveryoutput" >
          <DeliveryOutput />
        </Route>
        <Route path="/deliveries/:id" >
          <Deliery />
        </Route>
        <Route path="/deliveries" >
          <Deliery />
        </Route>
        <Route path="/orderresponses/:id" >
          <OrderResponse />
        </Route>
        <Route path="/orderresponses" >
          <OrderResponse />
        </Route>
        <Route path="/forecasts/:date" >
          <Forecast />
        </Route>
        <Route path="/forecasts" >
          <Forecast />
        </Route>
        {
          user?.serviceState === 'jp' && 
            <Route path="/pays/:id" >
              <Pay />
            </Route>
        }
        {
          user?.serviceState === 'jp' && 
            <Route path="/pays" >
              <Pay />
            </Route>
        }
        {
          user?.serviceState === 'jp' && 
            <Route path="/billingDetail/detail/:companyID/:supplier/:acquisitiondate/:paymentDate" >
              <BillingDetail />
            </Route>
        }
        {
          user?.serviceState === 'jp' && 
            <Route path="/billingDetail" >
              <BillingDetail />
            </Route>
        }
        <Route path="/estimations/detail/:random/:id/:subId" >
          <Estimation />
        </Route>
        <Route path="/estimations/detail/:random/:id" >
          <Estimation />
        </Route>
        <Route path="/estimations/:id" >
          <Estimation />
        </Route>
        <Route path="/estimations" >
          <Estimation />
        </Route>
        <Route path="/acceptances/:id" >
          <Acceptance />
        </Route>
        <Route path="/acceptances" >
          <Acceptance />
        </Route>
        <Route path="/notifications" >
          <Notification />
        </Route>
        <Route path="/notifications/:id" >
          <Notification />
        </Route>
        <Route path="/notifications" >
          <Notification />
        </Route>
        <Route path="/models/:id" >
          <Model />
        </Route>
        <Route path="/models" >
          <Model />
        </Route>
        <Route path="/modelassets/:id" >
          <Inventory />
        </Route>
        <Route path="/modelassets" >
          <Inventory />
        </Route>
        <Route path="/supplierestimates/:id/details/:detailId" >
          <SupplierEstimates />
        </Route>
        <Route path="/supplierestimates/:id" >
          <SupplierEstimates />
        </Route>
        <Route path="/supplierestimates" >
          <SupplierEstimates />
        </Route>
        <Route path="/home/:batchName" >
          <Home />
        </Route>
        <Route path="/home" >
          <Home />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Layout.Content>
  </Layout>


  // これは隠されたルートです。
  // これを追加する理由は、第一に、ユーザーが背後の実際のルートを不正にクリックするのを防ぐためであり、
  // 第二に、ぼかし効果がページ上のすべての要素に直接適用されるためです。
  // ぼかしを解除する方法には、互換性とパフォーマンスの問題がある可能性があります。偽の要素を作成して直接削除する方がよいでしょう。
  // この偽のルートはサイドバーのルーティング機能を削除し、ルート本体にはホームページのみが保持されます。
  const fakeRouter = SuppierCommnunityFakeRouter()
  const userAgreement = SuppierCommnunityAgreement()

  return (
    <Router>
      <Layout>
        {
          <>
            {router}
            {
              (!userReaded && user?.serviceState === 'jp') &&
              <>
                {/* fake blur router （homeとsupportの機能のみを持つルートをぼかし、agreementの背景として使用します） */}
                <Layout id='userAgreementBlur' className='agreementBlurRouter'>
                  {fakeRouter}
                </Layout>
                <Layout id='userAgreement' className='agreementMaskAndBox'>
                  {userAgreement}
                </Layout>
              </>
            }
          </>
        }
      </Layout>
    </Router>
  )
}
